import { BarChart3, Briefcase, Building, FileText, Scale, Users } from "lucide-react";
import React, { useEffect, useState } from "react";

export function FestivalAds({ T }) {
  const campaigns = [
    {
      title: "Navratri‑velsignelser",
      body: "Spesial for kjærlighet og karriere • Festivaltilbud",
      cta: "Utforsk",
      gradient: "from-fuchsia-200 via-pink-200 to-purple-200",
    },
    {
      title: "Diwali – Uke for velstand",
      body: "Tiltrekk overflod: Lakshmi‑fokusert rådgivning og renselser",
      cta: "Utforsk",
      gradient: "from-amber-200 via-yellow-200 to-orange-200",
    },
    {
      title: "Nymåneseremoni",
      body: "Gruppemeditasjon + private veiledningspakker",
      cta: "Bli med",
      gradient: "from-indigo-200 via-sky-200 to-cyan-200",
    },
  ];
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => setI((x) => (x + 1) % campaigns.length), 5000);
    return () => clearInterval(id);
  }, [paused]);
  const c = campaigns[i];

  return (
    <section className="w-full py-16 bg-gradient-to-r from-gray-50 via-white to-gray-100 text-gray-900 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-10">
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-blue-700 mb-1">
              Aktuelle kampanjer
            </h3>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
              Gratis førstegangskonsultasjon – begrenset periode
            </h2>
            <p className="text-gray-600 mt-2">
              Tilbud på juridiske tjenester innen eiendom, kontrakt, selskapsrett og arbeidsrett.
            </p>
          </div>
          <button className="mt-6 sm:mt-0 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-semibold shadow transition">
            Utforsk tilbud
          </button>
        </div>

        {/* Service categories */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mb-12">
          {[
            { icon: Scale, label: "Advokat" },
            { icon: Briefcase, label: "Forretningsjus" },
            { icon: Building, label: "Eiendomsrett" },
            { icon: FileText, label: "Kontrakter" },
            { icon: BarChart3, label: "Skatt & Finans" },
            { icon: Users, label: "Arbeidsrett" },
          ].map((item, i) => (
            <a
              key={i}
              href={`#${item.label.toLowerCase()}`}
              className="flex flex-col items-center justify-center rounded-xl border border-gray-200 bg-white p-5 hover:shadow-md hover:border-blue-400 transition text-center"
            >
              <item.icon className="w-6 h-6 text-blue-600 mb-2" />
              <span className="font-medium text-gray-800 text-sm sm:text-base">
                {item.label}
              </span>
            </a>
          ))}
        </div>

        {/* Footer callout */}
        <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl py-6 px-6 flex flex-col sm:flex-row items-center justify-between shadow-sm">
          <p className="text-gray-800 text-base sm:text-lg mb-4 sm:mb-0">
            Fant du ikke det du lette etter? <span className="font-semibold">Se alle rådgivere</span>
          </p>
          <button onClick={() => window.location.href = '/agents'} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-semibold transition">
            Alle rådgivere
          </button>
        </div>
      </div>
    </section>
    // <section
    //   className="py-12 px-4 max-w-6xl mx-auto"
    //   onMouseEnter={() => setPaused(true)}
    //   onMouseLeave={() => setPaused(false)}
    // >
    //   <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
    //     <Megaphone className="w-6 h-6 text-purple-600" /> {T.festivalTitle}
    //   </h2>
    //   <div className={`rounded-3xl p-8 bg-gradient-to-r ${c.gradient} shadow-lg transition-all duration-300`}>
    //     <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    //       <div>
    //         <p className="uppercase tracking-wide text-xs text-gray-700">Begrenset periode</p>
    //         <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900">{c.title}</h3>
    //         <p className="text-gray-800 mt-1">{c.body}</p>
    //       </div>
    //       <Button className="bg-purple-700 hover:bg-purple-800 text-white rounded-full px-6 py-3">{c.cta}</Button>
    //     </div>
    //   </div>
    // </section>
  );
}